<template>
  <div>
    <div class="link-warp">
      <div class="link-item active">账户明细</div>
    </div>
    <div class="section">
      <div class="l-section">
        <div
          class="i-panl"
          :style="{
            background: `url(${require('assets/image/l-panl-icon.png')}) no-repeat left center/contain`,
          }"
        >
          <img class="icon" :src="require('assets/image/l-panlm-icon.png')" />
          <div class="col">
            <div class="price">{{ balance }}</div>
            <div class="label">可用金额</div>
          </div>
        </div>
        <div
          class="i-panl ii-panl"
          :style="{
            background: `url(${require('assets/image/li-panl-icon.png')}) no-repeat left center/contain`,
          }"
        >
          <img class="icon" :src="require('assets/image/l-panlb-icon.png')" />
          <div class="col">
            <div class="price">{{ freezeAmount }}</div>
            <div class="label">冻结金额</div>
          </div>
        </div>
      </div>
      <div class="r-section">
        <Button class="zc-btn" to="/user/finance/account/recharge">充值</Button>
        <Button class="tx-btn" to="/user/finance/account/cashout">提现</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAmountInfo } from "api/user.js";
import { mapState, mapMutations } from "vuex";
export default {
  name: "finance",
  computed: {
    ...mapState(["freezeAmount", "balance"]),
  },
  created() {
    this.getInfo();
  },
  methods: {
    ...mapMutations(["MUT_AMOUNT"]),
    // 获取账户资金
    getInfo() {
      getAmountInfo().then((res) => {
        if (res.code === 200 && res.result) {
          this.MUT_AMOUNT(res.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  position: relative;
  background-color: #fff;
  padding: 0 30px;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
.section {
  background-color: #fff;
  border-radius: 8px;
  margin: 50px;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .l-section {
    display: flex;
    align-items: center;
    .i-panl {
      width: 333px;
      height: 173px;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 60px;
        height: 60px;
      }
      .col {
        margin-left: 25px;
        color: #fff;
        .price {
          font-size: 36px;
          font-weight: 400;
        }
        .label {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
    .ii-panl {
      margin-left: 50px;
    }
  }
}
.zc-btn {
  height: 45px;
  line-height: 45px;
  min-width: 100px;
  background-color: #ff5c35;
  color: #fff;
}
.tx-btn {
  height: 45px;
  line-height: 45px;
  min-width: 100px;
  margin-left: 30px;
}
</style>
